

import { ReactComponent as ConformitaGeneraleIcon } from '../Assets/CyberLogIcons/Conformità generale.svg';
import { ReactComponent as AmbitiConformitaIcon }     from '../Assets/CyberLogIcons/Ambiti di conformità.svg';
import { ReactComponent as ConsapevolezzaIcon }      from '../Assets/CyberLogIcons/Consapevolezza.svg';
import { ReactComponent as FileAngelIcon }           from '../Assets/CyberLogIcons/File Angel.svg';
import { ReactComponent as BrowsingAngelIcon }       from '../Assets/CyberLogIcons/Browsing Angel.svg';
import { ReactComponent as CyberSurveillanceIcon }   from '../Assets/CyberLogIcons/Cyber Surveillance.svg';
import { ReactComponent as ReportisticaIcon }        from '../Assets/CyberLogIcons/Reportistica.svg';
import { ReactComponent as TaskManagerIcon }         from '../Assets/CyberLogIcons/Task Manager.svg';

const iconMap = {
  'Conformità generale': ConformitaGeneraleIcon,
  'Ambiti di conformità': AmbitiConformitaIcon,
  'Consapevolezza': ConsapevolezzaIcon,
  'File Angel': FileAngelIcon,
  'Browsing Angel': BrowsingAngelIcon,
  'Cyber Surveillance': CyberSurveillanceIcon,
  'Reportistica': ReportisticaIcon,
  'Task Manager': TaskManagerIcon,
};

// ➜ arrow function definita *dopo* iconMap
const getCyberLogIcon = (name, props = {}) => {
  const Svg = iconMap[name];
  return Svg ? <Svg {...props} /> : null;
};

export default getCyberLogIcon;
